module.exports = __webpack_public_path__ + "media/images/japan/language-active-b31a1c89e54729b95fb0b57ae98cd078.svg";